export default __webpack_public_path__ + "static/media/Group_3897.ada07600.svg";